import { Suggestion } from '@se/ui.text.editor';
import { ConfidentialityCodeType, ObscuredCustomVisibility, ObscuredTabType } from 'estensa-module';

export interface ObscuredData {
    authorizationResearch?: boolean;
    authorizationInternal?: boolean;
    authorizationExternal?: boolean;
    obscuredDrug?: boolean;
    obscuredHIV?: boolean;
    obscuredViolence?: boolean;
    obscuredInterruption?: boolean;
    obscuredReferringPhysician?: boolean;
    obscuredAdditional?: string;
    obscuredAvailability?: string;
    obscuredAnonymityBirth?: boolean;
    obscuredFamilyCounseling?: boolean;
    obscuredDocument?: boolean;
    obscuredParent?: boolean;
    deObscuredDocument?: boolean;
    confidentialityCode?: ConfidentialityCodeType;
    mediationNeeded?: boolean;
}

export interface ObscuredDataModalConfiguration {
    canFSEBeModified: boolean;
    customVisibility: ObscuredCustomVisibility;
    data: ObscuredData;
    extraData?: any;
    readonly: boolean;
    suggestions: Suggestion[];
    type: ObscuredTabType;
    images: {
        FSEHelpConfidentialityImage: string;
        FSEHelpConfidentialityNormalImage: string;
        FSEHelpConfidentialityRestrictedImage: string;
        FSEHelpConfidentialityVeryRestrictedImage: string;
        FSEHelpObscuringImage: string;
        FSEHelpObscuringP00Image: string;
        FSEHelpObscuringP97Image: string;
        FSEHelpObscuringP98Image: string;
        FSEHelpObscuringP99Image: string;
    };
}

export interface ObscuredDataResult {
    data?: ObscuredData;
    extraData?: any;
}

export enum SpecialLaws {
    obscuredDrug = 'obscuredDrug',
    obscuredHIV= 'obscuredHIV',
    obscuredViolence= 'obscuredViolence',
    obscuredInterruption= 'obscuredInterruption',
    obscuredReferringPhysician ='obscuredReferringPhysician',
    obscuredAnonymityBirth ='obscuredAnonymityBirth',
    obscuredFamilyCounseling ='obscuredFamilyCounseling'
}

export const hasAnyTrueObscuredSpecialLaws = (data: ObscuredData, selectedKeys: (keyof ObscuredData)[]): boolean =>
    selectedKeys.some(key => data[key] === true);
